<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.EmptyTrailer)}} ({{localize(langSection.TrailerCard, langText.FromUPS)}})</h5>
    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.Quantity)}} *</label>
          <ups-select class="{{errors.numberTrailersRequested ? 'error' : ''}}" [readonly]="isDisabled('numberTrailersRequested')" [value]="model.numberTrailersRequested" [list]="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']" (change)="onFieldChange('numberTrailersRequested', $event.target.value)"></ups-select>
          @if (errors.numberTrailersRequested) {
<span class="text-danger">{{errors.numberTrailersRequested}}</span>
}
        </div>
      </div>
    </div>

    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.TrailerType)}} *</label>
          <ups-select class="{{errors.trailerType ? 'error' : ''}}" [readonly]="isDisabled('trailerType')" [value]="model.trailerType" [list]="trailerTypes" (change)="onFieldChange('trailerType', $event.target.value)"></ups-select>
          @if (errors.trailerType) {
<span class="text-danger">{{errors.trailerType}}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0 mt-3">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.AdditionalInformation)}}</h5>
    <div class="row mb-3">
      <div class="col-11 col-lg-auto">
        <div class="request-input-long">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.RequestReason)}} {{isNewRequest ? '*' : ''}}</label>
          <span class="request-reason-text {{errors.requestReason ? 'error' : ''}}">
            <textarea class="form-control" [ngModel]="model.requestReason" [readonly]="isDisabled('requestReason')" maxlength="256" (input)="onFieldChange('requestReason', $event.target.value)"></textarea>
          </span>
          @if (errors.requestReason) {
<span class="text-danger">{{errors.requestReason}}</span>
}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.DeliveryNumber)}}</label>
          <input type="text" class="form-control {{errors.deliveryNumber ? 'error' : ''}}" [ngModel]="model.deliveryNumber" [readonly]="isDisabled('deliveryNumber')" maxlength="30" (input)="onFieldChange('deliveryNumber', $event.target.value)" />
          @if (errors.deliveryNumber) {
<span class="text-danger">{{errors.deliveryNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-11 col-lg-auto">
        <div class="request-input-long">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.SpecialInstructions)}}</label>
          <textarea class="form-control {{errors.specialInstructions ? 'error' : ''}}" [ngModel]="model.specialInstructions" [readonly]="isDisabled('specialInstructions')" maxlength="256" (input)="onFieldChange('specialInstructions', $event.target.value)"></textarea>
          @if (errors.specialInstructions) {
<span class="text-danger">{{errors.specialInstructions}}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>
